import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqListingPageComponent } from './faq-listing-page.component';
import { PipesModule } from '../../../tenders/_pipes/amount-pipes.module';


@NgModule({
    declarations: [FaqListingPageComponent,],
    imports: [CommonModule, PipesModule],
    exports: [FaqListingPageComponent]
})
export class FaqListingPageModule { }